module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hres8ax-deduction-tab1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detailDeduction",
    attrs: {
      "id": "deduction-tab1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v(_vm._s(_vm.flgEdit) + "\n       "), _c('hrms-table', {
    attrs: {
      "columns": _vm.detailDeductionTable1,
      "data": _vm.detailDeduction,
      "searchDisp": false,
      "rowDisableCondition": _vm.rowDisableCondition,
      "editInlineEventBool": true,
      "saveInlineBtnDisp": false
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#deduction-tab1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v("รายการลดหย่อน\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-420f4518!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres8ax/deduction_1.vue
// module id = 3716
// module chunks = 1